// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"fe3392b2870aac38","6935":"7bca62ea1396c96c","7408":"ba57478f2b47c5a0","8967":"ba57478f2b47c5a0","9998":"d246bc5e7b5a733a"}[chunkId] + ".css";
};